module.exports = __webpack_public_path__ + "static/media/grid-item-c1.16af6e57.png";